import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=468a7808"
import script from "./SearchView.vue?vue&type=script&lang=js"
export * from "./SearchView.vue?vue&type=script&lang=js"
import style0 from "../components/search/SearchModal.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./SearchView.vue?vue&type=style&index=1&id=468a7808&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports